import React from "react";

function Contact() {
  return (
    <div>
      <section
        class="text-gray-600 body-font relative dark:bg-black"
        style={{ minHeight: "95vh", background: "#DEB887" }}
      >
        <div class="container px-5 py-24 mx-auto flex sm:flex-nowrap flex-wrap">
          <div class="lg:w-2/3 md:w-1/2 bg-gray-300 rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative">
            <iframe
              class="absolute inset-0"
              title="map"
              marginheight="0"
              marginwidth="0"
              scrolling="no"
              src="https://maps.google.com/maps?width=100%&height=600&hl=en&q=india&ie=UTF8&t=&z=14&iwloc=B&output=embed"
              width="100%"
              height="100%"
              frameborder="0"
            ></iframe>
          </div>
          <div class=" p-10 rounded-md lg:w-1/3 md:w-1/2 bg-white flex flex-col md:ml-auto w-full md:py-8 mt-8 md:mt-0 dark:bg-black">
            <h2 class="text-gray-900 text-lg mb-1 font-medium title-font dark:text-gray-100">
              Contact Us
            </h2>
            <p class="leading-relaxed mb-5 text-gray-600 dark:text-gray-500">
              Send us your email and message and we will contact you{" "}
            </p>
            <div class="relative mb-4">
              <label
                for="name"
                class="leading-7 text-sm text-gray-600 dark:text-gray-100"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                class="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
              />
            </div>
            <div class="relative mb-4">
              <label
                for="email"
                class="leading-7 text-sm text-gray-600 dark:text-gray-100"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                class="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
              />
            </div>
            <div class="relative mb-4">
              <label
                for="message"
                class="leading-7 text-sm text-gray-600 dark:text-gray-100"
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                class="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
              ></textarea>
            </div>
            <button class="text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg">
              Submit
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
